/**
 * 全局混入，注意使用！ 一旦使用全局混入对象，将会影响到所有之后创建的Vue实例。
 */

export default {
    data() {
        return {};
    },
    computed: {},
    methods: {
        awaitWrap(promise) {
            return promise
                .then(data => ({
                    data
                }))
                .catch(err => ({
                    data: {},
                    err
                }));
        }
    }
};
